import React from "react";

function ProgressBar({ current, total }) {
  const percentage = (current / total) * 100;

  return (
    <div className="mb-4">
      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
        <div
          className="bg-blue-600 h-2.5 rounded-full"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      <p className="text-sm text-gray-500 mt-1">
        Progress: {current} / {total}
      </p>
    </div>
  );
}

export default ProgressBar;
